// extracted by mini-css-extract-plugin
export default {"radio":"style_radio__niGZS","createOrderButton":"style_createOrderButton__OzZpF"};